import { type EditorType } from '@heidi/editor/core';
import { type ReactNode } from 'react';
import { EditorTypeContext } from './editor-type';

/**
 * Standalone twin of `vMarkdown/editor-type-context`: exposes the host editor's
 * `EditorType` to the section node-view portal so section analytics can report
 * which editor an action happened in, without prop-drilling through
 * ProseMirror's render boundary. markdown-native never imports vMarkdown, so the
 * provider is duplicated here rather than shared.
 */
export function EditorTypeProvider({
  editorType,
  children,
}: {
  editorType?: EditorType;
  children: ReactNode;
}) {
  return (
    <EditorTypeContext.Provider value={editorType}>{children}</EditorTypeContext.Provider>
  );
}
